<template>
  <div class="line_chart_wrap mt-5">
    <div class="chart_title mt-5" v-if="Boolean(chartData.title)">
      <div class="text-h6"><v-icon>mdi-circle-small</v-icon>{{ $i18n.translate(chartData.title) }}</div>
    </div>
    <LineChartGenerator ref="lineChart"
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
    />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    chartData: {
      type: Object,
      default: () => {}
      // type: Array,
      // default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    chartId: {
      type: String,
      default: 'line-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 200
    },
    cssClasses: {
      default: '',
      type: String
    },
    plugins: {
      type: Object,
      default: () =>{}
    }
  },
  computed: {
    styles () {
      return {
        height: `${this.height}px`,
      }
    }
  },
  data() {

    let unitY = this.chartData.unitY || '';
    let maxY = this.chartData.maxY;
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            display: true,
            beginAtZero: true,
            max: maxY,
            ticks: {
              stepSize: 20,
              color: '',
              callback: function(value) {  //축 뒤에 % 표시 포맷
                return `${value}${unitY}`;
              }

            }
          }
        },
        layout: {
          padding: 20
        },
        legend: {
          display: false,
        },

        plugins :  {
          legend: { // 범례
            position: 'bottom',
            display: false,
            onClick: () => false
          },
          datalabels: {
            display:false,
            align: 'end'
          },
        }
      }
    }
  },
  // beforeUpdate () {
  //   console.log('befor', this.data.data);
  // //  this.image = this.data;
  // //  console.log('befor', this.image);
  // },
  // updated() {
  //   console.log('updated', this.data.data);
  //
  // },
  // watch : {
  //   data : function ( value, oldValue) {
  //     console.log('value',value);
  //     console.log('oldValue',oldValue);
  //   //  ChartJS.update();
  //     let innerData = [];
  //     for (var i = 0; i < this.data.data.length; i++) {
  //       innerData.push({
  //         label: this.data.data[i].label,
  //         data: this.data.data[i].data,
  //         backgroundColor: this.data.data[i].backgroundColor,
  //         borderColor: this.data.data[i].borderColor,
  //         tension: this.data.data[i].tension,
  //         borderWidth: 2,
  //         datalabels: {
  //           color: '#333',
  //           font: { size: 14 },
  //           anchor: 'end',
  //           formatter: function (value) {
  //             return value;
  //           }
  //         }
  //       });
  //     }
  //     this.$set(this.chartData,'datasets',innerData);
  //
  //   }
  // }
}
</script>
<style scoped>
  .line_chart_wrap {
    position: relative;

  }
  .chart_title {

  }

</style>
